import { EElement } from '@progress-fe/core';
import { ERFElement } from '../enums';
export const RF_DRAG_NODE_TYPE = 'xy_flow_type';
export const RF_DRAG_TEMPLATE_CODE = 'xy_flow_template_code';
export const RF_FIT_VIEW_MAX_ZOOM = 0.9;
export const BLACK_HEX = '#000';
export const M_FLOW_HEX = '#333BAF';
export const E_FLOW_HEX = '#CC2F5A';
export const L_FLOW_HEX = '#B3B3B3';
export const ACCENT_HEX = '#3B568C';
export const WHITE_HEX = '#FFFFFF';
export const GREY_HEX = '#D7DAE0';
export const DARK_GREY_HEX = '#4E4E4E';
export const GRID_HEX = '#E7E7E9';
export const HIGHLIGHT_HEX = '#A44FA9';
export const RECYCLE_HEX = '#3b568c';
export const RFElementByElement = {
    [EElement.AbsorberElement]: ERFElement.Absorber,
    [EElement.MaterialFlowElement]: ERFElement.FlowMaterial,
    [EElement.EnergyFlowElement]: ERFElement.FlowEnergy,
    [EElement.TwoPhaseSeparatorElement]: ERFElement.Separator2ph,
    [EElement.ThreePhaseSeparatorElement]: ERFElement.Separator3ph,
    [EElement.CompressorElement]: ERFElement.Compressor,
    [EElement.CatCrackingElement]: ERFElement.CatCracking,
    [EElement.CatCrackingReactorRegeneratorBlockElement]: ERFElement.CatCrackingRRBlock,
    [EElement.CatReformingElement]: ERFElement.CatReforming,
    [EElement.CatReformingReactorBlockElement]: ERFElement.CatReformingRRBlock,
    [EElement.DieselFuelHydrotreatingElement]: ERFElement.DieselFuelHydrotreating,
    [EElement.DieselFuelHydrotreatingReactorBlockElement]: ERFElement.DieselFuelHydrotreatingRBlock,
    [EElement.DistillationColumnWithReboilerAndCapacitorElement]: ERFElement.DistillationColumnRC,
    [EElement.CokerElement]: ERFElement.Coker,
    [EElement.CokerReactorBlockElement]: ERFElement.CokerRBlock,
    [EElement.CoolerElement]: ERFElement.Cooler,
    [EElement.ValveElement]: ERFElement.Valve,
    [EElement.FractionatorElement]: ERFElement.Fractionator,
    [EElement.HeatExchangerElement]: ERFElement.HeatExchanger,
    [EElement.PumpElement]: ERFElement.Pump,
    [EElement.MixerElement]: ERFElement.Mixer,
    [EElement.DetanderElement]: ERFElement.Detander,
    [EElement.SplitterElement]: ERFElement.Splitter,
    [EElement.HeaterElement]: ERFElement.Heater,
    [EElement.HeatExchangerSynthetic]: ERFElement.HeatExchangerSynthetic,
    [EElement.MultiStepCoherent]: ERFElement.MultiStepCoherent,
    [EElement.MultiStepExternal]: ERFElement.MultiStepExternal,
    [EElement.Balancer]: ERFElement.Balancer,
    [EElement.EngineTestSynthetic]: ERFElement.EngineTestSynthetic,
    [EElement.ComponentSplitterElement]: ERFElement.ComponentSplitter,
    [EElement.PipelineElement]: ERFElement.Pipeline,
    [EElement.WaterJetPumpElement]: null,
    [EElement.ConversionReactorElement]: null,
    [EElement.EquilibriumReactorElement]: null,
    [EElement.SingleParamChangeElement]: null
};
export const ElementByRFElement = {
    [ERFElement.Element]: null,
    [ERFElement.Recycle]: null,
    [ERFElement.Function]: null,
    [ERFElement.Optimization]: null,
    [ERFElement.GroupDashed]: null,
    [ERFElement.DotEnergy]: null,
    [ERFElement.DotMaterial]: null,
    [ERFElement.Absorber]: EElement.AbsorberElement,
    [ERFElement.FlowMaterial]: EElement.MaterialFlowElement,
    [ERFElement.FlowEnergy]: EElement.EnergyFlowElement,
    [ERFElement.Separator2ph]: EElement.TwoPhaseSeparatorElement,
    [ERFElement.Separator3ph]: EElement.ThreePhaseSeparatorElement,
    [ERFElement.CatCracking]: EElement.CatCrackingElement,
    [ERFElement.CatCrackingRRBlock]: EElement.CatCrackingReactorRegeneratorBlockElement,
    [ERFElement.CatReforming]: EElement.CatReformingElement,
    [ERFElement.CatReformingRRBlock]: EElement.CatReformingReactorBlockElement,
    [ERFElement.Coker]: EElement.CokerElement,
    [ERFElement.CokerRBlock]: EElement.CokerReactorBlockElement,
    [ERFElement.DieselFuelHydrotreating]: EElement.DieselFuelHydrotreatingElement,
    [ERFElement.DieselFuelHydrotreatingRBlock]: EElement.DieselFuelHydrotreatingReactorBlockElement,
    [ERFElement.DistillationColumnRC]: EElement.DistillationColumnWithReboilerAndCapacitorElement,
    [ERFElement.Compressor]: EElement.CompressorElement,
    [ERFElement.HeatExchanger]: EElement.HeatExchangerElement,
    [ERFElement.Heater]: EElement.HeaterElement,
    [ERFElement.Cooler]: EElement.CoolerElement,
    [ERFElement.Valve]: EElement.ValveElement,
    [ERFElement.Fractionator]: EElement.FractionatorElement,
    [ERFElement.Mixer]: EElement.MixerElement,
    [ERFElement.ComponentSplitter]: EElement.ComponentSplitterElement,
    [ERFElement.Splitter]: EElement.SplitterElement,
    [ERFElement.Detander]: EElement.DetanderElement,
    [ERFElement.Pump]: EElement.PumpElement,
    [ERFElement.Pipeline]: EElement.PipelineElement,
    [ERFElement.HeatExchangerSynthetic]: EElement.HeatExchangerSynthetic,
    [ERFElement.MultiStepCoherent]: EElement.MultiStepCoherent,
    [ERFElement.MultiStepExternal]: EElement.MultiStepExternal,
    [ERFElement.Balancer]: EElement.Balancer,
    [ERFElement.EngineTestSynthetic]: EElement.EngineTestSynthetic
};
//# sourceMappingURL=rf.constant.js.map